__webpack_require__.p = "https://worker-drb02oor8-restworld.vercel.app/_next/";